import { ApplicationRef, Component, OnInit } from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppLoaderService } from './app-loader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifc-app-loader',
    templateUrl: './app-loader.component.html',
    styleUrls: ['./app-loader.component.css'],
    standalone: false
})
export class AppLoaderComponent implements OnInit {
  isHttpLoading = false;
  isManualLoading = false;

  constructor(
    private readonly service: AppLoaderService,
    private readonly appRef: ApplicationRef
  ) { }

  ngOnInit(): void {
    this.initHttpLoading();
    this.initManualLoading();
  }

  private initHttpLoading() {
    this.service.isHttpLoading$
      .pipe(
        untilDestroyed(this),
        debounceTime(300),
        distinctUntilChanged())
      .subscribe(isHttpLoading => {
        this.isHttpLoading = isHttpLoading;
        if (!this.isHttpLoading && !this.isManualLoading) {
          this.appRef.tick();
        }
      });
  }

  private initManualLoading() {
    this.service.isManualLoading$
      .pipe(
        untilDestroyed(this),
        debounceTime(300),
        distinctUntilChanged())
      .subscribe(isManualLoading => {
        this.isManualLoading = isManualLoading;
        if (!this.isHttpLoading && !this.isManualLoading) {
          this.appRef.tick();
        }
      });
  }
}
